import PaginationMui from '@mui/material/Pagination'
import { useMediaQuery } from '@mui/material'

const styles = {
  '& li': {
    height: { xs: '32px', sm: '36px', md: '40px' },
    width: { xs: '32px', sm: '36px', md: '40px' },
  },
  '& .MuiPaginationItem-root': {
    color: 'primary.main',
    m: '0',
    fontSize: { xs: '12px', sm: '14px', md: '16px' },
    minWidth: { xs: '32px', sm: '36px', md: '40px' },
    height: { xs: '32px', sm: '36px', md: '40px' },
    '&:hover': {
      backgroundColor: 'white',
    },
    '&.Mui-selected': {
      backgroundColor: 'rgba(249, 165, 26, 0.2)',
      '&:hover': {
        backgroundColor: 'rgba(249, 165, 26, 0.2)',
      },
    },
  },
  '& .MuiPaginationItem-ellipsis': {
    lineHeight: { xs: '24px', sm: '28px', md: '32px' },
    fontSize: { xs: '12px', sm: '14px', md: '16px' },
  },
  '& li + li': {
    mr: { xs: '3px', sm: '4px', md: '5px' },
  },
  '& li:last-child': {
    mr: 0,
  },
}

const Pagination = (props: React.ComponentProps<typeof PaginationMui>) => {
  const isMobile = useMediaQuery('(max-width: 800px)')
  const isTablet = useMediaQuery('(max-width: 1200px)')
  
  // If size is not explicitly provided, use responsive default
  const responsiveSize = props.size || (isMobile ? 'small' : isTablet ? 'medium' : 'large')
  
  return <PaginationMui count={4} {...props} size={responsiveSize} sx={styles} />
}

export default Pagination
